import { GetStaticPropsContext } from "next/types";
import { checkAuthServerSideProps } from "@/base/utils/user";
import { getBaseLocaleProps } from "@/base/utils/localalization-base";

export const getServerSideProps = async (ctx: GetStaticPropsContext) => checkAuthServerSideProps(ctx, async (ctx) => getBaseLocaleProps(ctx, ["base-dashboard", "base-dashboard-promo"]));

export { default } from "@/base/pages/dashboard/promo";
